import { Icon } from '@iconify/react'
import { useTranslation } from 'react-i18next'

const ProviderDocs = ({documents}: {documents: any[]}) => {

    const { t } = useTranslation()
    return (
        <div className="submitted-documents">
            <h3 className="submitted-documents-title">{t("submitted-documents")}</h3>
            <div className="documents-grid">
                {documents.map((doc, index) => (
                    <div key={index} className="document-card">
                        <Icon
                            icon={doc.status === "approved" ? "mdi:file-check" : "mdi:file-clock"}
                            className={`document-icon ${doc.status}`}
                        />
                        <span className="document-name">{doc.name}</span>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default ProviderDocs